import axios from "axios";

// get products by category
export const getProductsByCategory = async (categoryId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products-handler/?category_id=${categoryId}&status=${true}`);
   
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

